/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { ComparePage } from 'landing-pages/compare/ComparePage';
import { getDnbCompareData } from 'landing-pages/compare/data/dnb';

export const GlobalDatabaseVsDnbPage = () => {
  const { t } = useInt();

  return <ComparePage data={getDnbCompareData(t)} />;
};
